import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../common/Logo';

function Footer() {
  return (
    <footer className="bg-primary-extra text-primary-500">
      <div className="container max-w-7xl  mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        {/* Top Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-8">
          {/* Logo and Description */}
          <div className="col-span-full lg:col-span-3 flex flex-col items-center lg:items-start">
            <div className="mb-4">
              <Logo />
            </div>
            <p className="text-center lg:text-left text-sm text-primary-footerText">
              Connecting exceptional teachers
              <br />
              with leading institutions worldwide.
            </p>
          </div>

          {/* Footer Columns */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 col-span-full lg:col-span-9 mt-8 lg:mt-0">
            {/* Platform */}
            <div className="text-center lg:text-left">
              <h3 className="text-base font-medium mb-6">Platform</h3>
              <ul className="space-y-4">
                <li>
                  <Link to="#" className="text-primary-footerText hover:text-primary-footerTextH text-sm">
                    How it Works
                  </Link>
                </li>
                <li>
                  <Link to="#" className="text-primary-footerText hover:text-primary-footerTextH text-sm">
                    Features
                  </Link>
                </li>
                <li>
                  <Link to="#" className="text-primary-footerText hover:text-primary-footerTextH text-sm">
                    Pricing
                  </Link>
                </li>
                <li>
                  <Link to="#" className="text-primary-footerText hover:text-primary-footerTextH text-sm">
                    FAQ
                  </Link>
                </li>
              </ul>
            </div>

            {/* For Teachers */}
            <div className="text-center lg:text-left">
              <h3 className="text-base font-medium mb-6">For Teachers</h3>
              <ul className="space-y-4">
                <li>
                  <Link to="#" className="text-primary-footerText hover:text-primary-footerTextH text-sm">
                    Coming Soon
                  </Link>
                </li>
                {/* <li><Link to="#" className="text-primary-footerText hover:text-primary-footerTextH text-sm">Find Jobs</Link></li>
                <li><Link to="#" className="text-primary-footerText hover:text-primary-footerTextH text-sm">Career Resources</Link></li>
                <li><Link to="#" className="text-primary-footerText hover:text-primary-footerTextH text-sm">Teaching Guides</Link></li>
                <li><Link to="#" className="text-primary-footerText hover:text-primary-footerTextH text-sm">Success Stories</Link></li> */}
              </ul>
            </div>

            {/* For Institutions */}
            <div className="text-center lg:text-left">
              <h3 className="text-base font-medium mb-6">For Institutions</h3>
              <ul className="space-y-4">
                <li>
                  <Link to="#" className="text-primary-footerText hover:text-primary-footerTextH text-sm">
                    Coming Soon
                  </Link>
                </li>
                {/* <li><Link to="#" className="text-primary-footerText hover:text-primary-footerTextH text-sm">Post a Job</Link></li>
                <li><Link to="#" className="text-primary-footerText hover:text-primary-footerTextH text-sm">Recruitment Tools</Link></li>
                <li><Link to="#" className="text-primary-footerText hover:text-primary-footerTextH text-sm">Hiring Guides</Link></li>
                <li><Link to="#" className="text-primary-footerText hover:text-primary-footerTextH text-sm">Success Stories</Link></li> */}
              </ul>
            </div>

            {/* Company */}
            <div className="text-center lg:text-left">
              <h3 className="text-base font-medium mb-6">Company</h3>
              <ul className="space-y-4">
                <li>
                  <Link to="#" className="text-primary-footerText hover:text-primary-footerTextH text-sm">
                    Coming Soon
                  </Link>
                </li>
                {/* <li><Link to="#" className="text-primary-footerText hover:text-primary-footerTextH text-sm">About Us</Link></li>
                <li><Link to="#" className="text-primary-footerText hover:text-primary-footerTextH text-sm">Contact</Link></li>
                <li><Link to="#" className="text-primary-footerText hover:text-primary-footerTextH text-sm">Blog</Link></li>
                <li><Link to="#" className="text-primary-footerText hover:text-primary-footerTextH text-sm">Press</Link></li> */}
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 sm:mt-16 pt-8 border-t border-gray-700">
          <div className="flex flex-col sm:flex-row justify-between items-center text-center sm:text-left">
            <p className="text-sm text-primary-footerText mb-4 sm:mb-0">© 2025 FindTeachers. All rights reserved.</p>
            <div className="flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-8">
              <div className="flex items-center space-x-4">
                <Link to="#" className="text-sm text-primary-footerText hover:text-primary-footerTextH">
                  Privacy Policy
                </Link>
                <span className="text-gray-600">|</span>
                <Link to="#" className="text-sm text-primary-footerText hover:text-primary-footerTextH">
                  Terms of Service
                </Link>
                <span className="text-gray-600">|</span>
                <Link to="#" className="text-sm text-primary-footerText hover:text-primary-footerTextH">
                  Cookie Policy
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;